<template>
    <div>
        <nav-bar-main></nav-bar-main> 
        <!--<nav-bar-zone></nav-bar-zone>-->
        
        <div v-if="plantDetails != null && zoneDetails !=null"  class="animated fadeIn container-fluid">
            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
                <div>
                
                <!-- navbar dei comandi visibile solo se admin o installatore o collaboratore -->
                <b-row v-if="this.ruoloUtente(this.$store.getters.userId)=='installer' ||  this.$store.state.user.usertype=='admin'" class="fixed-top navbar-command">
                    <b-col lg="12" md="12">

                    <!-- banner error on plant -->
                    <div v-if="error != null" class="alert alert-danger" role="alert">
                        {{$t(error)}}
                    </div>

                    <!-- banner per basic plant -->
                    <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
                        <banner-pro/>
                    </b-alert>
                    
                    <!-- banner per pro expired -->
                    <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
                        <banner-pro-expired/>
                    </b-alert>
                
                    <!--- Loader per il caricamento pagina o invio dei comandi -->
                    <Loader/>

                    <!-- barra dei comandi -->
                    <b-row v-if="!$store.state.loading" class="pull-left ml-4" style="width: 100%">
                            <add-zone zone=""> </add-zone>                          
                            <div id="navbar-search">
                                <div id="navbar-filter" v-if="!advancedFilters">     
                                        <b-input-group>
                                            <b-form-input type="text" placeholder="Cerca" v-model="filters.search"></b-form-input>
                                            <b-input-group-append>
                                                <b-button variant="primary" @click="filtra()"><i class="fa fa-search"></i> </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                </div>
                            </div>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </show-at>

            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
                <div>
                    <b-nav class="mobile-sub-nav fixed-top">
                        <b-nav-text style="padding-left:16px"> {{$t("navbar_dispositivi.button_centrali")}}</b-nav-text>
                    </b-nav>
                </div>
            </show-at>

             <!-- Tabella zones -->
            <div v-if="tableData" style="margin-top:125px">
           
            <b-list-group v-for="item in tableData" v-bind:key="item.zoneId">
              <b-list-group-item class="mb-2 mt-1"> 
                <b-row>
                    <b-col cols="11">
                        <h5 class="mb-2 ml-1">{{item.zoneName}}</h5>
                    </b-col>
                    <b-col cols="1">
                        <b-row>
                            <b-button><i class="fas fa-trash-alt" style="color:#0090CD" @click="removeZone(item)"></i></b-button>
                            <edit-zone :zone="item"></edit-zone>
                        </b-row>
                    </b-col>        
                </b-row>
              </b-list-group-item>
            </b-list-group>

            </div>


        </div>

    </div>
</template>

<script>

import Vue from 'vue'

import NavBarMain from '@/components/NavBarMain'
import NavBarZone from '@/components/NavBarZone'
import AddZone from '@/components/AddZone'
import EditZone from '@/components/EditZone'
import DisclaimerPhotoITA from '@/locales/DisclaimerPhotoITA';
import DisclaimerPhotoENG from '@/locales/DisclaimerPhotoENG';
import DisclaimerPhotoGER from '@/locales/DisclaimerPhotoGER';
import BannerProExpired from '@/components/BannerProExpired';
import BannerPro from '@/components/BannerPro';
import {showAt, hideAt} from 'vue-breakpoints';
//import DragItDude from 'vue-drag-it-dude';

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import panZoom from 'vue-panzoom'
Vue.use(panZoom);

import jsPDF from 'jspdf';
import JsPDFAutotable from 'jspdf-autotable' ;



import { mapState } from 'vuex';

export default {
    name: 'GestioneZone',
    components: {
        NavBarMain,
        NavBarZone,
        AddZone,
        EditZone,
        Event,
        BannerPro,
        BannerProExpired,
        DisclaimerPhotoENG,
        DisclaimerPhotoITA,
        DisclaimerPhotoGER,
        vueDropzone: vue2Dropzone,
        jsPDF,
        JsPDFAutotable,
        hideAt, 
        showAt 
    },
    props: ['plantId'],
    data() {
        return {
            highlightedLamp: "",
            filtro: "",
            tabIndex: 0,
            lampToRemove:null,
            draggedLamp: null,
            showDropZone: false,
            imgLoaded: false,
            imgUploaded: false,
            picLoaded: {},
            updatingName: false,
            dropZoneOptions: {
                url: process.env.VUE_APP_API_REST_URL,
                maxFilesize: 1.5,
                acceptFiles: "image/*",
                autoProcessQueue: false,
                autoQueue: false,
                maxFiles: 1
            },
            advancedFilters: false,
            filters: {
                search: '',
                idCent: '',
                nomeCent: '',
                idLamp: '',
                nomeLamp: '',
                tipoCent: ['all'],
                tipoLamp: 'all',
                autonomia: ['all'],
                parita: 'all',
                infinity: 'all',
                rete_se:'all'
            },
            dragging: false,
            drgX: '0px',
            drgY: '0px',
            dragStartEv: null,
            lampListFields: [
                {key: 'id', label: 'ID' },
                {key: 'status', label: 'Stato'}
            ],
            allLampsFields: [
                {key: 'id', label: 'ID' },
                {key: 'cu_id', label: 'Centrale'},
                {key: 'desc', label: 'Nome'}
            ],
            listDeviceFields:[
                
            ],
            currentAmbiente: {},
            selectedLamp: null,
            theme: 'bootstrap4',
            template: 'default',  
            filtroLampadeLibere: false
        }     
    
    },
    filters: {
        
        tipoCentrale: function(value) {
            if (value == 'cablecom') return "Centrale CableCom"
            return "Centrale " + value
        },
        
    },
    computed: {
        ...mapState(['loading','error','commandsPending','commandResponse']),

        rndId() {
            return Math.random();
        },
        /*tabIndex() {
            if (this.currentAmbiente != null && this.currentAmbiente.isNew) return 1;
            return 0;
        },*/
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null){
                this.tableData = [];
                return null;
            } 
            if (plant.id != this.plantId) return null;
            return plant;
        },
        zoneDetails(){
            this.tableData = this.$store.state.plantZones;
            /*this.tableData = [
                {
                    zoneId: "pippo1",
                    zoneName:"pippo",
                    zoneCollection:[],
                    zoneSensor:[]
                },
                {
                    zoneId: "pippo2",
                    zoneName:"pippo",
                    zoneCollection:[],
                    zoneSensor:[]
                },
                {
                    zoneId: "pippo3",
                    zoneName:"pippo",
                    zoneCollection:[],
                    zoneSensor:[]
                },
                {
                    zoneId: "pippo4",
                    zoneName:"pippo",
                    zoneCollection:[],
                    zoneSensor:[]
                },
                {
                    zoneId: "pippo5",
                    zoneName:"pippo",
                    zoneCollection:[],
                    zoneSensor:[]
                },
            ]*/
            console.log("Zones: ",this.tableData);
            return this.tableData;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        allTableData() {
            return this.$store.state.plantUnits || [];
        },    
    },
    mounted() {
        console.log("gestionezone mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails + ", collections:" + this.$store.plantCollections)
        //window.addEventListener('resize', this.handleResize)


        //var dataReady = this.loadData();
        //console.log("gestionezone mounted dataReady " + dataReady);
        if (this.plantDetails != null) {
            var dataReady = this.loadData();
            console.log("gestionezone mounted dataReady " + dataReady);
        }

        
        /*if (this.$store.state.user != null && this.error == null && this.plantDetails == null && this.zoneDetails==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.$store.dispatch('loadPlantZones', this.plantId)
        } else {
            let self = this;
            this.$nextTick(() => {
                self.$forceUpdate();
            });
        }*/
        /*if (this.$store.state.user != null && this.error == null && this.$store.plantCollections == null) {
            this.$store.dispatch('loadPlantCollections', this.plantId)
        } else if (this.$store.state.user != null && this.error == null && this.$store.state.plantZones == null) {
            this.$store.dispatch('loadPlantZones', this.plantId);
        }*/



    },
    updated() {
        console.log("gestionezone updated, idImpianto=" + this.plantId+", plantDetails=", this.plantDetails+ ", error:" + this.error)
        /*if (this.zoneDetails==null && this.error == null && this.$store.state.user != null) {
            this.$store.dispatch('loadPlantZones', this.plantId)
        } */
    },
    
    watch: {
        loading(val,oldval) {
            console.log("gestionezone loading changed:" + val+", error=" + this.error)
            if (val == false && this.error == null) {
                var dataReady = this.loadData();
                console.log("gestionezone loading dataReady " + dataReady);
            }
            /*if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            } else if (val == false && this.$store.state.commandResponse.pending == false && this.$store.state.commandResponse.command != null) {
                console.log("gestione zone devo elaborare risposta comando ", this.$store.state.commandResponse);
                
            } else if (val == false && this.plantDetails != null && this.unitsDetails != null) {
                console.log("dati pronti");
            }
            this.$forceUpdate();*/
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
        },
        commandsPending(val,oldval) {
            console.log("commandsPending " + val, "configInProgress =" + this.configInProgress);   
        },
        commandResponse(val,oldval) {
            console.log("cambiata commandResponse ->", val);
            let resp = val; 
            console.log("analizzo la risposta, loop= " + this.loop  , resp);
            if (!resp.pending && resp.command != null) {
                if (resp.error != null && resp.error != "") {
                    console.log("resp error",resp.error);
                    var alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg: "Resp error"
                    }  
                    this.alerts.push(alert);  
                } else {
                    console.log("risposta ok per comando " + resp.command + ", cu:" + resp.cu);
                    switch (resp.command) {
                        case 'saveZone':
                                this.$store.dispatch('loadPlantZones', this.plantId);  
                            break;
                        case 'updateZone': 
                            for (var i=0; i< this.tableData.length; i++) {
                                var coll = this.tableData[i];
                                if (coll.zoneId == resp.response.zoneInfo.zoneId) {
                                    this.tableData[i] = resp.response.zoneInfo;
                                    
                                    this.$forceUpdate();
                                    break;
                                }
                            }
                            break;
                        case 'removeZone':
                            for (var i=0; i< this.tableData.length; i++) {
                                var coll = this.tableData[i];
                                if (coll.zoneId == resp.response.zoneInfo.zoneId) {
                                    this.tableData.splice(i,1);
                                    this.$forceUpdate();
                                    break;
                                }
                            }
                            break;
                    }
                }
            }
        }
    },
    methods: {

        loadData() {
            if (this.plantDetails == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
                return false;
            } else if (this.$store.state.plantCollections==null) {
                console.log("gestionezone, ricarico plantCollections")
                this.$store.dispatch('loadPlantCollections', this.plantId);
                return false;
            } else if (this.$store.state.plantScenes==null) {
                console.log("gestionezone, ricarico plantScenes")
                this.$store.dispatch('loadPlantScenes', this.plantId);
                return false;
            } else if (this.zoneDetails == null) {
                console.log("ricarico plant zones");
                this.$store.dispatch('loadPlantZones', this.plantId)
                return false;
            } else {
                console.log("gestionezone dati pronti")
                //this.$forceUpdate();
            }
            return true;
        },

        removeZone(zone)
        {
            console.log("Remove zone: ",zone);
            let self = this;
            this.$bvModal.msgBoxConfirm("Eliminare questa zona?", {
                        title: 'Conferma',
                        okVariant: 'danger',
                        okTitle: 'ELIMINA',
                        cancelTitle: 'ANNULLA',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                            self.$store.dispatch("dbRemoveZone", {
                                plantId: self.$store.state.currentPlant.id,
                                zoneId: zone.zoneId,
                            });
                        }
                    });
        },
        filtra(){
            //TODO come aggregazioni?
        },
        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) 
            {
               return user[0].role;
            }
            return "?";
        },
    }
}
</script>

<style lang="scss">

.button-zone{
    height: 200px;
    width: 200px;
}

.close-x{
    font-size: 1.3125rem;
    font-weight: 400; 
    color: white;
    opacity:1;
}

.modal-fullscreen .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 100000;
}
    .nopad {
       padding: 0;
    }
    .imgDiv {
        position: relative;
    }

    .dotImg {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 13px;
        height: 13px;
        
    }

    @keyframes highlightedDotAnim {
        0% {background-color: rgba(255,255,255,0);}
        50% {background-color: rgba(255,255,0,0.8);}
        100% {background-color: rgba(255,255,255,0);}
    }

    .dotImgHighlight {
        background-color: #ffff00;
        width: 61px;
        height: 61px;
        padding: 24px;
        border-radius: 32px;
        animation-name: highlightedDotAnim;
        animation-duration: 1s;
        animation-iteration-count: infinite;
    }

    .dotImgBig {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 50px;
        height: 50px;
        padding: 16px;
        background-color: #ffffff11;
        border-radius: 32px;
        z-index: 10000;
    }

    .dotSel {
        background-color: #00990044;
    }

    .modal-xl {
        max-width: 95%;
        
    }
    .uploadButton {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .infoTip {
        position: absolute;
        right: 5px;
        bottom: 5px;
    }

    .closeButton {
        position: absolute;
        right: 0;
        top: 0;
    }

    #dropzoneContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #eeeeee;
        top: 0;
        margin-top: auto;
        margin-bottom: auto;
        padding: 16px;
        z-index: 11000;
    }
    #dropzone {
        height: 100%;
    }
    .draggableRow {
        cursor: pointer;
    }

    .lampUsed {
        background-color: #ffff;
    }

    .highlightedRow {
        background-color: #b3d3ec;
    }
    
    .highlightedAdded {
        background-color: #ffff;
    }


    .green {
        color: #009900;
    }
    .error {
        color: #cc0000;
    }

    #modal-ambiente .modal-content {
        min-height: 600px;
    }

</style>